import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Country } from '@mp/organization-master-data/countries/domain';

@Injectable({ providedIn: 'root' })
export class CountriesService {
  private readonly baseUrl = '/api/m/organizationmasterdata/countries';

  constructor(private readonly http: HttpClient) {}

  fetchCountries(): Observable<Country[]> {
    return this.http.get<Country[]>(this.baseUrl);
  }
}
